<template>
  <!-- 审批流查询，列表界面 -->
  <div class="wfClass">
    <van-nav-bar :title="title" left-arrow @click-left="onClickLeft">
    </van-nav-bar>
    <div class="search">
      <van-search
        v-model="value"
        placeholder="请输入搜索关键词"
        @input="onSearch"
      />
      <div class="gettype" @click="showPicker = true" v-if="type == '2'">
        <span>{{ sstype }}<van-icon name="arrow-down"/></span>
      </div>
      <van-icon
        name="apps-o"
        v-if="type == '1' || type == '2' || type == '5'"
        @click="showcheck = !showcheck"
      />
      <van-icon name="calendar-o" @click="showCalendar = true" />
    </div>

    <div class="applyCollapse" :class="{ showcheck: showcheck }">
      <van-cell
        v-for="(value, key) in afworkflowlist"
        :key="key"
        @click="jump(value)"
        style="text-align: center"
        :title="value.applistmemo"
      >
        <div slot="icon" @click.stop="bd = bd">
          <div class="beforcell">
            <van-checkbox
              v-if="showcheck && !(value.ischeck || value.return)"
              v-model="value.checked"
              shape="square"
            />
            <div class="ico"></div>
          </div>
        </div>
        <div slot="default">
          <span :class="{ st: true, ischeck: value.ischeck }">
            {{
              type == '1'
                ? '待审批'
                : type == '5'
                ? '待提交'
                : type == '4' || value.isreturn
                ? '被撤销'
                : value.ischeck
                ? '已审批'
                : '审批中'
            }}
          </span>
        </div>
        <template slot="label">
          {{ value.crdate }}
        </template>
      </van-cell>
    </div>
    <div v-show="showcheck" class="footer_btn">
      <van-checkbox
        v-model="checked"
        icon-size="22px"
        @click="checkAll(checked)"
        >全选</van-checkbox
      >
      <van-button
        type="info"
        :loading="loading"
        @click="_pushwxmsg"
        v-if="type == '2'"
        >催单</van-button
      >
      <van-button
        type="info"
        :loading="loading"
        @click="settype(1)"
        v-if="type == '1'"
        >提交</van-button
      >
      <van-button
        type="danger"
        :loading="loading"
        @click="settype(2)"
        v-if="type == '1'"
        >否决</van-button
      >
      <van-button
        type="info"
        :loading="loading"
        @click="_postWorkFlowList"
        v-if="type == '5'"
        >提交</van-button
      >
      <van-button
        type="danger"
        :loading="loading"
        @click="_deleteWorkFlowList"
        v-if="type == '5'"
        >删除</van-button
      >
    </div>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @confirm="onConfirm"
        @cancel="showPicker = false"
      />
    </van-popup>
    <van-calendar
      v-model="showCalendar"
      :min-date="minDate"
      :max-date="maxDate"
      type="range"
      @confirm="onConfirm2"
    />
  </div>
</template>

<script>
import { Toast, Dialog } from 'vant'
import {
  getActionWorkFlowOfOneClass,
  getActionWorkFlow,
  getOneClassOfMyWf,
  getOneClassOfMyCheckWf,
  getReturnWorkFlowOneClass,
  pushwxmsg,
  getNotPostList,
  deleteWorkFlowList,
  postWorkFlowList,
  getCsWorkFlowOfOneClass,
  updateCheckListStatus
} from '@/api/wx.js'
import { parseTime, createGguid } from '@/utils'
export default {
  data() {
    const userInfo = localStorage.userInfo
      ? JSON.parse(localStorage.userInfo)
      : {}
    const type = this.$route.query.type
    const formautoid = this.$route.query.formautoid
    const appname = this.$route.query.appname
    const appiconid = this.$route.query.appiconid
    return {
      userInfo,
      value: '',
      type,
      formautoid,
      appname,
      appiconid,
      workflowlist: [],
      ini2: [],
      bd: '',
      ed: '',
      V3url: './',
      sstype: '所有单据',
      columns: ['所有单据', '审核完结', '审核中'],
      showPicker: false,
      showcheck: false,
      checked: false,
      showCalendar: false,
      loading: false,
      minDate: new Date(new Date().getFullYear() - 20, 0, 1),
      maxDate: new Date(new Date().getFullYear() + 20, 0, 31)
    }
  },
  computed: {
    title() {
      const arr = [
        '',
        localStorage.getItem('dwsp_caption'),
        localStorage.getItem('wfqd_caption'),
        localStorage.getItem('wysp_caption'),
        localStorage.getItem('bcxd_caption'),
        localStorage.getItem('wtjd_caption'),
        localStorage.getItem('cs_caption'),
      ]
      return arr[Number(this.type)] + (this.appname ? `(${this.appname})` : '')
    },
    afworkflowlist() {
      let arr = this.workflowlist
      switch (this.sstype) {
        case '所有单据':
          arr = this.workflowlist.filter(e => {
            return true
          })
          break
        case '审核完结':
          arr = this.workflowlist.filter(e => {
            return e.ischeck || e.return
          })
          break
        case '审核中':
          arr = this.workflowlist.filter(e => {
            return !(e.ischeck || e.return)
          })
          break
      }
      return arr
    }
  },
  created() {
    this.initData()
  },
  mounted() {
    setTimeout(() => {
      document.getElementsByClassName('van-tabbar-item')[0].style.color =
        '#646566'
      document.getElementsByClassName('van-tabbar-item')[1].style.color =
        '#1989fa'
    }, 200)
  },
  methods: {
    async initData() {
      switch (this.type) {
        case '1':
          if (this.formautoid == '0') {
            // 待我审批
            await getActionWorkFlow({
              empcode: this.userInfo.empcode,
              langid: localStorage.getItem('langid'),
              bd: this.bd,
              ed: this.ed
            }).then(res => {
              this.bulid(res.data)
            })
          } else {
            // 待我审批(一类)
            await getActionWorkFlowOfOneClass({
              empcode: this.userInfo.empcode,
              formautoid: this.formautoid,
              langid: localStorage.getItem('langid'),
              bd: this.bd,
              ed: this.ed
            }).then(res => {
              this.bulid(res.data)
            })
          }

          break
        case '2':
          // 我发起的
          await getOneClassOfMyWf({
            empcode: this.userInfo.empcode,
            formautoid: this.formautoid,
            langid: localStorage.getItem('langid'),
            bd: this.bd,
            ed: this.ed
          }).then(res => {
            this.bulid(res.data)
          })
          break
        case '3':
          // 我已审批
          await getOneClassOfMyCheckWf({
            empcode: this.userInfo.empcode,
            formautoid: this.formautoid,
            langid: localStorage.getItem('langid'),
            bd: this.bd,
            ed: this.ed
          }).then(res => {
            this.bulid(res.data)
          })
          break
        case '4':
          // 被撤销的
          await getReturnWorkFlowOneClass({
            empcode: this.userInfo.empcode,
            formautoid: this.formautoid,
            langid: localStorage.getItem('langid'),
            bd: this.bd,
            ed: this.ed
          }).then(res => {
            this.bulid(res.data)
          })
          break
        case '5':
          // 未提交的
          await getNotPostList({
            empcode: this.userInfo.empcode,
            formautoid: this.formautoid,
            langid: localStorage.getItem('langid'),
            bd: this.bd,
            ed: this.ed
          }).then(res => {
            this.bulid(res.data)
          })
          break
        case '6':
          await getCsWorkFlowOfOneClass({
            empcode: this.userInfo.empcode,
            formautoid: this.formautoid,
            langid: localStorage.getItem('langid'),
            bd: this.bd,
            ed: this.ed
          }).then(res => {
            this.bulid(res.data)
          })
          break  
        default:
          break
      }
    },
    // 构造分组列表
    bulid(data) {
      this.workflowlist = []
      data.forEach((e, i) => {
        e.appiconid = this.appiconid
        if (this.formautoid != '0') {
          e.appname = this.appname
          e.formautoid = this.formautoid
          e.check = false
        }
      })
      this.ini2 = JSON.parse(JSON.stringify(data))
      this.workflowlist = data
    },
    onClickLeft() {
      if (this.type == '1' && this.formautoid == '0') {
        this.$router.push({
          path: '/apply'
        })
      } else {
        this.$router.push({
          path: '/wfClass',
          query: { type: this.type }
        })
      }
    },
    onClickRight() {},
    onSearch(val) {
      if (val) {
        this.workflowlist = this.ini2.filter(e => {
          return e.applistmemo.indexOf(val) > -1
        })
      } else {
        this.workflowlist = JSON.parse(JSON.stringify(this.ini2))
      }
    },
    onCancel() {
      this.value = ''
      this.workflowlist = JSON.parse(JSON.stringify(this.ini2))
    },
    jump(v) {
      if(this.type == '6'){
        updateCheckListStatus({
          checkuserid: this.userInfo.userid,
          formautoid: v.formautoid,
          autoid: v.mautoid,
          flag: 3
        }).then(res=>{
          setLocVal('wfqdinfo', v.autoid)
          setLocVal('wfqdlist', v.formautoid)
          var url = ''
          if (this.type == '5') {
            setLocVal(
              'hyrptparas',
              this.appname + '|' + '' + url + '|' + '' + v.autoid
            )
            url = 'shengpiinfoOnly.html'
          } else {
            setLocVal('sptype', this.type)
            setLocVal(
              'wfqdinfomsg',
              v.appiconid + '|' + v.applistmemo + '|' + v.crdate
            )
            setLocVal('candroplist', v.candroplist)
            url = 'wfqdinfo.html'
          }
          let href = this.V3url + '/weixinlocal/queryrpt/' + url
          this.$router.push({
            path: '/jump',
            query: { url: href, time: new Date().getTime() }
          })
        })
      }else{
        setLocVal('wfqdinfo', v.autoid)
        setLocVal('wfqdlist', v.formautoid)
        var url = ''
        if (this.type == '5') {
          setLocVal(
            'hyrptparas',
            this.appname + '|' + '' + url + '|' + '' + v.autoid
          )
          url = 'shengpiinfoOnly.html'
        } else {
          setLocVal('sptype', this.type)
          setLocVal(
            'wfqdinfomsg',
            v.appiconid + '|' + v.applistmemo + '|' + v.crdate
          )
          setLocVal('candroplist', v.candroplist)
          url = 'wfqdinfo.html'
        }
        let href = this.V3url + '/weixinlocal/queryrpt/' + url
        this.$router.push({
          path: '/jump',
          query: { url: href, time: new Date().getTime() }
        })
      }
      
    },
    settype(v) {
      setLocVal('settype', v)
      setLocVal('can_appbg_batch_check', '0')
      if (v.can_appbg_batch_check) {
        setLocVal('can_appbg_batch_check', '1') // 是否后台批量处理
      }
      let list = this.afworkflowlist.filter(e => {
        return e.checked && !(e.ischeck || e.return)
      })
      if (list.length == 0) {
        Toast('请选择记录！')
        return
      }
      this.loading = true
      setLocVal(
        'hywfautoidlist',
        list
          .map(e => {
            return e.autoid
          })
          .join('|')
      )
      setLocVal(
        'hywfformautoidlist',
        list
          .map(e => {
            return e.formautoid
          })
          .join('|')
      )
      setLocVal(
        'hywfapplistmemolist',
        list
          .map(e => {
            return e.applistmemo
          })
          .join('|')
      )

      var url = 'settypebatch.html'
      let href = this.V3url + '/weixinlocal/queryrpt/' + url
      this.$router.push({
        path: '/jump',
        query: { url: href, time: new Date().getTime() }
      })
    },
    onConfirm(value) {
      this.sstype = value
      this.showPicker = false
    },
    onConfirm2(date) {
      const [start, end] = date
      this.showCalendar = false
      this.bd = parseTime(start, '{y}-{m}-{d}')
      this.ed = parseTime(end, '{y}-{m}-{d}')
      this.initData()
    },
    checkAll(checked) {
      this.workflowlist.forEach(e => {
        e.checked = checked
      })
      this.$forceUpdate()
    },
    _pushwxmsg() {
      const guid = createGguid()
      let data = this.afworkflowlist
        .filter(e => {
          return e.checked && !(e.ischeck || e.return)
        })
        .map(e => {
          return { autoid: e.mautoid }
        })
      if (data.length == 0) {
        Toast('请选择记录！')
        return
      }
      this.loading = true
      pushwxmsg({
        guid,
        data,
        formautoid: this.formautoid,
        username: this.userInfo.username,
        formautoid: this.formautoid,
        mkeyfield: this.$route.query.mkeyname,
        mtablename: this.$route.query.mtablename,
        mviewname: this.$route.query.mviewname
      })
        .then(res => {
          Toast('催单成功')
        })
        .finally(() => {
          this.loading = false
        })
    },
    _postWorkFlowList() {
      let autoidlist = this.afworkflowlist
        .filter(e => {
          return e.checked
        })
        .map(e => {
          return e[this.$route.query.mkeyname]
        })
      if (autoidlist.length == 0) {
        Toast('请选择记录！')
        return
      }

      Dialog.confirm({
        // title: '标题',
        message: '确认提交吗？'
      }).then(() => {
        this.loading = true
        const guid = createGguid()

        postWorkFlowList({
          guid,
          autoidlist: autoidlist.join(','),
          formautoid: this.formautoid,
          username: this.userInfo.username,
          formautoid: this.formautoid,
          mkeyname: this.$route.query.mkeyname,
          mtablename: this.$route.query.mtablename,
          mviewname: this.$route.query.mviewname
        })
          .then(res => {
            Toast('提交成功')
            this.initData()
          })
          .finally(() => {
            this.loading = false
          })
      })
    },
    _deleteWorkFlowList() {
      let autoidlist = this.afworkflowlist
        .filter(e => {
          return e.checked
        })
        .map(e => {
          return e[this.$route.query.mkeyname]
        })
      if (autoidlist.length == 0) {
        Toast('请选择记录！')
        return
      }

      Dialog.confirm({
        // title: '标题',
        message: '确认删除吗？'
      }).then(() => {
        this.loading = true
        const guid = createGguid()

        deleteWorkFlowList({
          guid,
          autoidlist: autoidlist.join(','),
          formautoid: this.formautoid,
          username: this.userInfo.username,
          formautoid: this.formautoid,
          mkeyname: this.$route.query.mkeyname,
          mtablename: this.$route.query.mtablename,
          mviewname: this.$route.query.mviewname
        })
          .then(res => {
            Toast('删除成功')
            this.initData()
          })
          .finally(() => {
            this.loading = false
          })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.wfClass {
  height: 100vh;
  overflow: hidden;
  .van-nav-bar {
    background: #2b8df0;
    height: 92px;
    /deep/ .van-nav-bar__left {
      .van-icon {
        color: #fff;
      }
    }
    /deep/.van-nav-bar__title {
      color: #fff;
      font-size: 36px;
      font-family: Source Han Sans CN;
    }
    ::v-deep .van-nav-bar__right {
      .van-nav-bar__text {
        color: #fff;
        font-family: Source Han Sans CN;
      }
    }
  }
  .van-icon {
    padding: 0 0.21333rem;
    color: #323233;
    font-size: 0.37333rem;
    line-height: 0.90667rem;
    cursor: pointer;
    -webkit-user-select: none;
    user-select: none;
  }
  .search {
    display: flex;
    align-items: center;
    .van-search {
      flex: 1;
    }
    .gettype {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #333333;
      font-size: 26px;
      span {
        background: #ddd;
        padding: 10px 0 10px 20px;
        border-radius: 20px;
      }
    }
  }
  .applyCollapse {
    width: 100%;
    background: #f2f2f2;
    margin-top: 30rpx;
    padding: 10px;
    overflow-y: scroll;
    height: calc(100vh - 300px);
    .van-collapse {
      background: #fff;
      border-radius: 20px;
      padding: 10px;
    }
    /deep/.van-cell {
      background: #fff;
      border-radius: 20px;
      padding: 10px;
      margin-bottom: 10px;
      .beforcell {
        display: flex;
        .ico {
          width: 8px;
          height: 22px;
          background: #bd50d3;
          border-radius: 2px;
          margin: 10px;
        }
      }

      .van-cell__title {
        flex: 2;
        text-align: left;
      }
      .st {
        text-align: center;
        color: #fc6060;
        background: #f8e5d5;
        border-radius: 30px;
        padding: 10px 20px;
      }
      .st.ischeck {
        color: #00b65b;
        background: #c1f5ea;
      }
    }
  }
  .footer_btn {
    width: 100%;
    padding: 0.26667rem 0;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 100;
    display: flex;
    background-color: #fff;
    ::v-deep .van-checkbox__icon {
      margin-left: 0.13333rem;
    }
    ::v-deep .van-checkbox__label {
      font-size: 0.48rem;
      font-family: Source Han Sans CN;
      font-weight: 500;
    }
    .van-button {
      margin-left: auto;
      margin-right: 0.60667rem;
      border-radius: 9px;
      width: 3.86667rem;
      .van-button__text {
        font-size: 0.48rem;
        font-family: Source Han Sans CN;
        font-weight: 500;
      }
    }
  }
}
</style>
